import { Transaction, TransactionShort, useGetTransactionsHistory } from 'react-easyrocket';
import { Table } from 'src/components/Table';
import { TableRowTransaction } from '../TableRowTransaction';
import { transactionHistoryHeader } from 'src/constants';
import { Spin } from 'src/components/svg/General';
import { NotFoundTransactions } from '../NotFoundTransactions';
import { useAutoDepositSuccess } from 'src/tmp/hooks/useAutoDepositSuccess';

interface LastTransactionsProps {
  onGetTransactionsSuccess?: (transactions: TransactionShort[]) => void;
  merchantId: string | undefined;
  transactionsType: 'deposit' | 'withdrawal';
}

export const LastTransactions = ({
  onGetTransactionsSuccess,
  merchantId,
  transactionsType
}: LastTransactionsProps) => {
  const { transactions, isFetching } = useGetTransactionsHistory(transactionsType, {
    onSuccess: ({ data }) => onGetTransactionsSuccess?.(data)
  });

  useAutoDepositSuccess({ transactions: transactions as Transaction[], merchantId });

  return (
    <>
      {isFetching && <Spin className="self-center mt-[7%]" />}
      {!isFetching && transactions?.length === 0 && <NotFoundTransactions />}
      {!isFetching && transactions?.length > 0 && (
        <div className="max-w-full min-w-full mt-5 overflow-auto">
          <Table
            header={transactionHistoryHeader}
            headerClassName="bonusTableHeader text-start pl-[80px]"
            tableRow={transactions.map((data, index) => (
              <TableRowTransaction key={index} data={data} />
            ))}
          />
        </div>
      )}
    </>
  );
};
